import script from "./AppClientSimpleLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AppClientSimpleLayout.vue?vue&type=script&setup=true&lang=js"

export default script